export var CustomPDFReportModalEventName;
(function (CustomPDFReportModalEventName) {
    CustomPDFReportModalEventName["SHOW_COVER_PAGE_MODULE_MODAL"] = "showCoverPageModuleModal";
    CustomPDFReportModalEventName["SHOW_EDIT_TALKING_POINTS_MODAL"] = "showEditTalkingPointsModal";
    CustomPDFReportModalEventName["SHOW_REPORT_MENU_MODAL"] = "showReportMenuModal";
    CustomPDFReportModalEventName["SHOW_SECURITY_SEARCH_MODAL"] = "showSecuritySearchModal";
    CustomPDFReportModalEventName["SHOW_SELECT_SAVED_HYPOTHETICAL_MODAL"] = "showSavedHypotheticalSelectorModal";
    CustomPDFReportModalEventName["GENERATE_CUSTOM_PDF_REPORT"] = "generateCustomPdfReport";
    CustomPDFReportModalEventName["SHOW_SELECT_DOLLAR_CONVERSION_LEVEL_MODAL"] = "showDollarConversionLevelSelectorModal";
    CustomPDFReportModalEventName["SHOW_SELECT_TRANSITION_ANALYSIS_MODAL"] = "showSelectTransitionAnalysisModal";
})(CustomPDFReportModalEventName || (CustomPDFReportModalEventName = {}));
